import EventTimelinePanel from './EventTimelinePanel';
import RelatedEvents from './RelatedEvents';
import { getEventTimeLinePanelSchema, getEventTimeLineAdminSchema } from './jsonSchema';
import './EventTimelinePanel.scss';

export { getEventTimeLinePanelSchema, getEventTimeLineAdminSchema, RelatedEvents };

export default EventTimelinePanel;
